// Generated by Melange

import * as Buhta_cabinet__Btn from "../../components/html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../components/molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../components/html/Checkbox.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Field from "../../components/html/Field.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__TaxControl from "../../grpc/TaxControl.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_cabinet__Toggle from "../../components/atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../packages/util/lib/DateTime.js";
import * as MelNumeral from "../../../../../packages/util/lib/MelNumeral.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (openMenu) {
    const match = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match[1];
    const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
    const deviceType = state.deviceType;
    const match$1 = React.useState(function () {
          return "";
        });
    const setRegistrationDate = match$1[1];
    const registrationDate = match$1[0];
    const match$2 = React.useState(function () {
          return "";
        });
    const setIin = match$2[1];
    const match$3 = React.useState(function () {
          return "";
        });
    const setLastname = match$3[1];
    const match$4 = React.useState(function () {
          return "";
        });
    const setName = match$4[1];
    const match$5 = React.useState(function () {
          return "";
        });
    const setSurname = match$5[1];
    const match$6 = React.useState(function () {
          return "";
        });
    const setSalary = match$6[1];
    const match$7 = React.useState(function () {
          return false;
        });
    const setIsBenefit = match$7[1];
    const isBenefit = match$7[0];
    const match$8 = React.useState(function () {
          return false;
        });
    const setIsRetired = match$8[1];
    const isRetired = match$8[0];
    const match$9 = React.useState(function () {
          return false;
        });
    const setIsRetiredByYearsServed = match$9[1];
    const isRetiredByYearsServed = match$9[0];
    const match$10 = React.useState(function () {
          return false;
        });
    const setIsDisabled = match$10[1];
    const isDisabled = match$10[0];
    const match$11 = React.useState(function () {
          return false;
        });
    const setIsDisabledIndefinitely = match$11[1];
    const isDisabledIndefinitely = match$11[0];
    const match$12 = React.useState(function () {
          return "";
        });
    const setBenefitStartDate = match$12[1];
    const match$13 = React.useState(function () {
          return false;
        });
    const setIsParent = match$13[1];
    const isParent = match$13[0];
    const match$14 = React.useState(function () {
          return false;
        });
    const setIsMother = match$14[1];
    const isMother = match$14[0];
    const match$15 = React.useState(function () {
          return false;
        });
    const setIsStudent = match$15[1];
    const isStudent = match$15[0];
    const match$16 = React.useState(function () {
          return "";
        });
    const setStudentBenefitStartDate = match$16[1];
    const match$17 = React.useState(function () {
          return "";
        });
    const setStudentBenefitEndDate = match$17[1];
    const match$18 = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match$18[0];
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const func = Buhta_cabinet__TaxControl.TaxInformationService.view;
    const match$19 = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._2(func, param, /* [] */0);
          }), undefined);
    const dispatch = match$19[1];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), []);
    const saveSettings = function (ev) {
      ev.preventDefault();
      const __x = Buhta_cabinet__TaxControl.TaxInformationService.update(undefined, {
            id: "",
            mode: /* TAX_MODE_UNSPECIFIED */0,
            register_date: undefined,
            kogd: "",
            kogd_living: undefined,
            vat: undefined,
            create_time: undefined,
            update_time: undefined
          });
      $$Promise.get(__x, (function (result) {
              if (result.TAG === /* Ok */0) {
                return Curry._1(dispatchToasts, {
                            TAG: /* Add */0,
                            _0: {
                              id: Buhta_core__Toast.generateId(undefined),
                              text: "Настройки сохранены",
                              kind: "success",
                              onClick: (function (param) {
                                  
                                })
                            }
                          });
              } else {
                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
              }
            }));
    };
    const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
          route: contextRoute({
                TAG: /* Tax */4,
                _0: {
                  TAG: /* Payments */0,
                  _0: /* Orders */{
                    _0: /* Index */0
                  }
                }
              }),
          children: JsxRuntime.jsx("img", {
                className: "w-5 h-5",
                src: StaticAsset.src("/static/icons/back-arrow.svg")
              })
        });
    const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
            title: "Настройки",
            leftChildren: backButton,
            openMenu: openMenu
          }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
            title: "Настройки"
          });
    return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                header: header,
                children: JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                          className: "text-default-gray",
                                          children: "Код органа гос. доходов"
                                        }),
                                    className: "space-y-4"
                                  }),
                              className: "bg-white md:w-[562px] rounded-md p-10 shadow-kkm"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                    value: registrationDate,
                                    onPicked: (function (date) {
                                        Curry._1(setRegistrationDate, (function (param) {
                                                return DateTime.toDateFormat(date);
                                              }));
                                      }),
                                    align: "BottomLeft",
                                    label: "Дата регистрации предприятия"
                                  }),
                              className: "bg-white md:w-[562px] rounded-md p-10 mt-2 shadow-kkm"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                      label: "ИИН",
                                      type_: "text",
                                      name: "iin",
                                      size: "m",
                                      required: true,
                                      onChange: (function (value) {
                                          Curry._1(setIin, (function (param) {
                                                  return value;
                                                }));
                                        }),
                                      value: match$2[0]
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Фамилия",
                                              type_: "text",
                                              name: "lastname",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setLastname, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$3[0]
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Имя",
                                              type_: "text",
                                              name: "name",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setName, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$4[0]
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Отчество",
                                              type_: "text",
                                              name: "surname",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setSurname, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$5[0]
                                            })
                                      ],
                                      className: "flex gap-4 mt-6"
                                    }),
                                JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                      value: registrationDate,
                                      onPicked: (function (date) {
                                          Curry._1(setRegistrationDate, (function (param) {
                                                  return DateTime.toDateFormat(date);
                                                }));
                                        }),
                                      align: "BottomLeft",
                                      className: "mt-7",
                                      label: "Дата рождения"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                              label: "Доход руководителя",
                                              type_: "text",
                                              name: "salary",
                                              size: "m",
                                              required: true,
                                              onChange: (function (value) {
                                                  Curry._1(setSalary, (function (param) {
                                                          return value;
                                                        }));
                                                }),
                                              value: match$6[0]
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "absolute right-4 top-4 w-5 h-5",
                                              alt: "tenge",
                                              src: StaticAsset.src("/static/icons/tenge.svg")
                                            })
                                      ],
                                      className: "relative mt-6"
                                    }),
                                JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                      className: "text-asphalt mt-1",
                                      children: [
                                        "Минимальная сумма — ",
                                        JsxRuntime.jsx("span", {
                                              children: MelNumeral.format({
                                                    NAME: "Str",
                                                    VAL: "70000"
                                                  }) + " ₸",
                                              className: "text-links"
                                            })
                                      ]
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: "Применить льготы"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      alt: "info",
                                                      src: StaticAsset.src("/static/icons/info.svg")
                                                    })
                                              ],
                                              className: "flex gap-2 items-center"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                                              checked: isBenefit,
                                              onChange: (function (value) {
                                                  Curry._1(setIsBenefit, (function (param) {
                                                          return value;
                                                        }));
                                                })
                                            })
                                      ],
                                      className: "flex justify-between items-center mt-6"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isRetired,
                                              onChange: (function (param) {
                                                  Curry._1(setIsRetired, (function (param) {
                                                          return !isRetired;
                                                        }));
                                                }),
                                              text: "Пенсионер по возрасту",
                                              subText: "мужчины — 63, женщины — 61"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                                      isChecked: isRetiredByYearsServed,
                                                      onChange: (function (param) {
                                                          Curry._1(setIsRetiredByYearsServed, (function (param) {
                                                                  return !isRetiredByYearsServed;
                                                                }));
                                                        }),
                                                      text: "Пенсионер по выслуге лет"
                                                    }),
                                                JsxRuntime.jsx("img", {
                                                      className: "w-5 h-5",
                                                      alt: "info",
                                                      src: StaticAsset.src("/static/icons/info.svg")
                                                    })
                                              ],
                                              className: "flex gap-2 items-center"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isDisabled,
                                              onChange: (function (param) {
                                                  Curry._1(setIsDisabled, (function (param) {
                                                          return !isDisabled;
                                                        }));
                                                }),
                                              text: "Инвалид I, II, III группы"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isDisabledIndefinitely,
                                              onChange: (function (param) {
                                                  Curry._1(setIsDisabledIndefinitely, (function (param) {
                                                          return !isDisabledIndefinitely;
                                                        }));
                                                }),
                                              text: "Инвалид I, II группы бессрочно"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                    value: match$12[0],
                                                    onPicked: (function (date) {
                                                        Curry._1(setBenefitStartDate, (function (param) {
                                                                return DateTime.toDateFormat(date);
                                                              }));
                                                      }),
                                                    align: "BottomLeft",
                                                    label: "Начало применения льгот"
                                                  }),
                                              className: Cn.$plus("mt-2 px-6", Cn.on("hidden", !isDisabledIndefinitely))
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isParent,
                                              onChange: (function (param) {
                                                  Curry._1(setIsParent, (function (param) {
                                                          return !isParent;
                                                        }));
                                                }),
                                              text: "Родитель/опекун инвалида"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isMother,
                                              onChange: (function (param) {
                                                  Curry._1(setIsMother, (function (param) {
                                                          return !isMother;
                                                        }));
                                                }),
                                              text: "Многодетная мать",
                                              subText: "4 и более детей"
                                            }),
                                        JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                                              isChecked: isStudent,
                                              onChange: (function (param) {
                                                  Curry._1(setIsStudent, (function (param) {
                                                          return !isStudent;
                                                        }));
                                                }),
                                              text: "Студент"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                            value: match$16[0],
                                                            onPicked: (function (date) {
                                                                Curry._1(setStudentBenefitStartDate, (function (param) {
                                                                        return DateTime.toDateFormat(date);
                                                                      }));
                                                              }),
                                                            align: "BottomLeft",
                                                            label: "Начало обучения"
                                                          }),
                                                      className: "grow"
                                                    }),
                                                JsxRuntime.jsx("div", {
                                                      children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                                                            value: match$17[0],
                                                            onPicked: (function (date) {
                                                                Curry._1(setStudentBenefitEndDate, (function (param) {
                                                                        return DateTime.toDateFormat(date);
                                                                      }));
                                                              }),
                                                            align: "BottomLeft",
                                                            label: "Дата окончания"
                                                          }),
                                                      className: "grow"
                                                    })
                                              ],
                                              className: Cn.$plus("mt-2 px-6 flex gap-4", Cn.on("hidden", !isStudent))
                                            })
                                      ],
                                      className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
                                    })
                              ],
                              className: "bg-white md:w-[562px] rounded-md p-10 mt-2 shadow-kkm"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                    title: "Сохранить",
                                    className: "px-6 py-3",
                                    type_: "submit"
                                  }),
                              className: "md:w-[562px] flex justify-end mt-6"
                            })
                      ],
                      onSubmit: saveSettings
                    }),
                className: "bg-gray-pale py-10 flex-col items-center"
              });
  };
}

function TaxSettingsPage(Props) {
  return make(Props.org)(Props.openMenu);
}

const make$1 = TaxSettingsPage;

export {
  make$1 as make,
}
/* Buhta_cabinet__Btn Not a pure module */
